import {createEntityAdapter} from '@reduxjs/toolkit';
import {MeetingRoom} from '../entities';
import {byProp} from '@lib/utils';

export const meetingRoomAdapter = createEntityAdapter<MeetingRoom>({
  selectId: (room) => room.id,
  sortComparer: byProp('displayName'),
});
